import * as moment from 'moment'

export const TIME_FORMAT = 'h:mm A'

type FormatTimeOptions = { hour: number; min: number } | moment.Moment

export function formatTime(options: FormatTimeOptions | null | undefined, format = TIME_FORMAT) {
  if (!options) return ''
  if (moment.isMoment(options)) return options.format(format)
  return moment(options.hour + ':' + options.min, 'H:m').format(format)
}

export function parseTime(time: string, format = TIME_FORMAT) {
  time = String(time || '').trim()
  return time ? moment(time, format) : null
}

export function to24HourTime(time: FormatTimeOptions | string | null | undefined) {
  const s = typeof time === 'string' ? time : formatTime(time)
  const m = parseTime(s)
  if (!m) return ''

  return m.format('HH:mm')
}
